import { Text, Flex } from '@/_components';
import { type FC } from 'react';
import type { QuestionAnswerLaterProps } from './QuestionAnswerLater.types';

export const QuestionAnswerLater: FC<QuestionAnswerLaterProps> = ({
  question,
}) => {
  const isUpload: boolean = question.question_type === 'upload';

  return (
    <Flex isColumn={true}>
      {isUpload ? (
        <Text type="small">
          You marked this question to be uploaded later. You will receive
          reminders to answer this document starting on{' '}
          <strong>{question.answer_by}</strong>.
        </Text>
      ) : (
        <Text type="small">
          You marked this question to be answered later. You will receive
          reminders to answer this question starting on{' '}
          <strong>{question.answer_by}</strong>.
        </Text>
      )}
    </Flex>
  );
};
